import {
  UPDATE_PROGRESS,
  UPDATE_DISPLAY_PROGRESS,
  UPDATE_HEADER,
  State,
  Action,
  UPDATE_NONPROFIT_ORG_CONFIG,
  UPDATE_NONPROFIT_ORG_CONFIG_LOADING,
  UPDATE_FUNDER_ORG_CONFIG,
  UPDATE_USER_CONFIG,
  UPDATE_BOX_ACCESS_TOKEN,
  UPDATE_FUNDER_ORG_CONFIG_LOADING,
  UPDATE_NONPROFIT_ORG_CONFIG_ERRORED,
  UPDATE_FUNDER_ORG_CONFIG_ERRORED,
  UPDATE_USER_CONFIG_LOADING,
  UPDATE_SHOW_NAVIGATION,
  UPDATE_APP_PANEL,
  UPDATE_FEATURE_GATING_LIMIT,
  UPDATE_SHOW_ACADEMY_INTRO_SECTION,
  UPDATE_DISMISSED_RESOURCES,
  UPDATE_ADBLOCKER_DETECTED,
  UPDATE_CLOUDINARY_CONFIG,
  UPDATE_FEATURE_FLAGS,
  UPDATE_FEATURE_FLAGS_LOADING,
  UPDATE_GLOBAL_DIALOG,
  UPDATE_NONPROFIT_DONATION_DETAILS,
  UPDATE_CAMPAIGNS,
  UPDATE_CAMPAIGNS_FILTER_DATE,
  SET_BLOCK_DRAGGING,
  SET_STORY_DETAILS,
  SET_ACTIVE_SIDE_PANEL,
  SET_TOC_VISIBILITY,
  SET_REDIRECT_PATH,
  SET_AI_STORY_CONTENT,
  SponsoredNonprofit,
  SponsoredNonprofits,
} from 'TypeDefs/AppContext'

export const appReducer = (state: State, action: Action): State => {
  const {
    ui: {
      appBar,
      showNavigation,
      appPanel,
      featureGatingLimit,
      academy: { showAcademyIntroSection, dismissedResources },
      adblockerDetected,
    },
    nonprofitOrgConfig,
    funderOrgConfig,
    boxConfig,
    cloudinaryConfig,
    userConfig,
    awsFeatureFlags,
  } = state

  switch (action.type) {
    case UPDATE_PROGRESS: {
      const newAppBar = {
        ...appBar,
        linearProgress: action.linearProgress,
      }
      return {
        ...state,
        ui: {
          ...state.ui,
          appBar: newAppBar,
        },
      }
    }

    case UPDATE_DISPLAY_PROGRESS: {
      const newAppBar = {
        ...appBar,
        displayLinearProgress: action.displayLinearProgress,
      }
      return {
        ...state,
        ui: {
          ...state.ui,
          appBar: newAppBar,
        },
      }
    }
    case UPDATE_HEADER: {
      const newAppBar = {
        ...appBar,
        header: { text: action.text, iconName: action.iconName },
      }
      return {
        ...state,
        ui: {
          ...state.ui,
          appBar: newAppBar,
        },
      }
    }
    case UPDATE_NONPROFIT_ORG_CONFIG: {
      const newOrgConfig = {
        nonprofitOrgConfig: action.nonprofitOrgConfig,
      }

      return {
        ...state,
        ...newOrgConfig,
      }
    }
    case UPDATE_NONPROFIT_DONATION_DETAILS: {
      return {
        ...state,
        donationDetails: {
          ...action.donationDetails,
        },
      }
    }
    case UPDATE_CAMPAIGNS: {
      return {
        ...state,
        donations: {
          campaigns: {
            ...action.payload,
          },
        },
      }
    }
    case UPDATE_CAMPAIGNS_FILTER_DATE: {
      return {
        ...state,
        filterDate: action.filterDate,
      }
    }
    case UPDATE_NONPROFIT_ORG_CONFIG_LOADING: {
      const newNonprofitOrgConfig = {
        nonprofitOrgConfig: {
          ...nonprofitOrgConfig,
          loading: action.loading,
        },
      }
      return { ...state, ...newNonprofitOrgConfig }
    }
    case UPDATE_FUNDER_ORG_CONFIG_LOADING: {
      const newFunderOrgConfig = {
        funderOrgConfig: {
          ...funderOrgConfig,
          loading: action.loading,
        },
      }
      return { ...state, ...newFunderOrgConfig }
    }
    case UPDATE_NONPROFIT_ORG_CONFIG_ERRORED: {
      const newNonprofitOrgConfig = {
        nonprofitOrgConfig: {
          ...nonprofitOrgConfig,
          errored: action.errored,
        },
      }
      return { ...state, ...newNonprofitOrgConfig }
    }
    case UPDATE_FUNDER_ORG_CONFIG_ERRORED: {
      const newFunderOrgConfig = {
        funderOrgConfig: {
          ...funderOrgConfig,
          errored: action.errored,
        },
      }
      return { ...state, ...newFunderOrgConfig }
    }
    case UPDATE_FUNDER_ORG_CONFIG: {
      const sponsoredNonpropfitList = action.funderOrgConfig
        .sponsoredNonprofits as unknown as SponsoredNonprofit[]
      const sponsoredNonprofits = sponsoredNonpropfitList.reduce((acc, org) => {
        acc[org.nonprofitOrgId] = {
          nonprofitOrgId: org.nonprofitOrgId,
          name: org.name,
        }
        return acc
      }, {} as SponsoredNonprofits)

      const newOrgConfig = {
        funderOrgConfig: {
          ...action.funderOrgConfig,
          sponsoredNonprofits,
        },
      }
      return {
        ...state,
        ...newOrgConfig,
      }
    }

    case UPDATE_CLOUDINARY_CONFIG: {
      const newCloudinaryConfig = {
        ...cloudinaryConfig,
        cloudinaryConfig: action.cloudinaryConfig,
      }
      return {
        ...state,
        ...newCloudinaryConfig,
      }
    }
    case UPDATE_BOX_ACCESS_TOKEN: {
      const newBoxConfig = {
        ...boxConfig,
        tokenData: action.tokenData,
      }
      return {
        ...state,
        ...newBoxConfig,
      }
    }

    case UPDATE_SHOW_NAVIGATION: {
      return {
        ...state,
        ui: {
          ...state.ui,
          appBar,
          showNavigation: action.showNavigation,
          appPanel,
          featureGatingLimit,
          academy: {
            showAcademyIntroSection,
            dismissedResources,
          },
          adblockerDetected,
        },
      }
    }

    case UPDATE_APP_PANEL: {
      return {
        ...state,
        ui: {
          ...state.ui,
          appBar,
          showNavigation,
          appPanel: action.appPanel,
          featureGatingLimit,
          academy: {
            showAcademyIntroSection,
            dismissedResources,
          },
          adblockerDetected,
        },
      }
    }

    case UPDATE_FEATURE_GATING_LIMIT: {
      return {
        ...state,
        ui: {
          ...state.ui,
          appBar,
          showNavigation,
          appPanel,
          featureGatingLimit: action.featureGatingLimit,
          academy: {
            showAcademyIntroSection,
            dismissedResources,
          },
          adblockerDetected,
        },
      }
    }

    case UPDATE_SHOW_ACADEMY_INTRO_SECTION: {
      return {
        ...state,
        ui: {
          ...state.ui,
          appBar,
          showNavigation,
          appPanel,
          featureGatingLimit,
          academy: {
            showAcademyIntroSection: action.showAcademyIntroSection,
            dismissedResources,
          },
          adblockerDetected,
        },
      }
    }

    case UPDATE_DISMISSED_RESOURCES: {
      return {
        ...state,
        ui: {
          ...state.ui,
          appBar,
          showNavigation,
          appPanel,
          featureGatingLimit,
          academy: {
            showAcademyIntroSection,
            dismissedResources: [
              ...dismissedResources,
              action.dismissedResources,
            ],
          },
          adblockerDetected,
        },
      }
    }

    case UPDATE_ADBLOCKER_DETECTED: {
      return {
        ...state,
        ui: {
          ...state.ui,
          adblockerDetected: action.adblockerDetected,
        },
      }
    }

    case UPDATE_USER_CONFIG: {
      const newUserConfig = {
        userConfig: { ...action.userConfig, loading: userConfig.loading },
      }

      return {
        ...state,
        ...newUserConfig,
      }
    }

    case UPDATE_USER_CONFIG_LOADING: {
      const newUserConfig = {
        userConfig: {
          ...userConfig,
          loading: action.loading,
        },
      }
      return { ...state, ...newUserConfig }
    }

    case UPDATE_FEATURE_FLAGS_LOADING: {
      const newFeatureFlags = {
        awsFeatureFlags: {
          ...awsFeatureFlags,
          loading: action.loading,
        },
      }
      return { ...state, ...newFeatureFlags }
    }

    case UPDATE_GLOBAL_DIALOG: {
      return {
        ...state,
        ui: {
          ...state.ui,
          dialog: {
            ...action.payload,
          },
        },
      }
    }

    case UPDATE_FEATURE_FLAGS: {
      const newFeatureFlags = {
        awsFeatureFlags: {
          ...awsFeatureFlags,
          activeFeatureFlags: action.activeFeatureFlags,
        },
      }

      return { ...state, ...newFeatureFlags }
    }

    case SET_BLOCK_DRAGGING: {
      return {
        ...state,
        storyBuilder: {
          story: {
            ...state.storyBuilder.story,
          },
          ui: {
            ...state.storyBuilder.ui,
            isBlockDragging: action.payload,
          },
        },
      }
    }

    case SET_STORY_DETAILS: {
      return {
        ...state,
        storyBuilder: {
          ...state.storyBuilder,

          ui: {
            ...state.storyBuilder.ui,
          },
          story: {
            ...state.storyBuilder.story,
            ...action.payload,
          },
        },
      }
    }

    case SET_AI_STORY_CONTENT: {
      return {
        ...state,
        aiStory: {
          blocks: action?.payload?.blocks,
          template: action?.payload?.template,
        },
      }
    }

    case SET_ACTIVE_SIDE_PANEL: {
      return {
        ...state,
        storyBuilder: {
          ...state.storyBuilder,
          ui: {
            ...state.storyBuilder.ui,
            activeSidePanel: action.payload,
          },
        },
      }
    }
    case SET_TOC_VISIBILITY: {
      return {
        ...state,
        storyBuilder: {
          ...state.storyBuilder,
          ui: {
            ...state.storyBuilder.ui,
            isTocVisible: action.payload,
          },
        },
      }
    }

    case SET_REDIRECT_PATH: {
      return {
        ...state,
        redirectPath: action.payload.redirectPath,
      }
    }

    default: {
      return state
    }
  }
}
